import React from 'react';
import PropTypes from 'prop-types';
import {ControlLabel, FormGroup} from 'react-bootstrap';
import HttpRequest from "../../services/HttpRequest";
import Select from 'react-select';
import Notify from "../../services/Notify";
import Objects from "../../utils/Objects";
import Loading from "../Loading/Loading";
import 'react-select/dist/react-select.css';
import './BaseSelector.css';

class BaseSelectorReadonlyToInputV2 extends React.Component {

  httpRequest = new HttpRequest();

  constructor(props, label, value) {
    super(props);

    const {setValue, defaultValue, multiple, mapItems, filterParamName, processData} = props;
    this.state = {label, value, defaultValue: defaultValue};
    this.state.defaultValue = defaultValue;
    this.state.value = 'id';
    this.state.multiple = multiple;
    this.state.mapItems = mapItems;
    this.state.filterParamName = filterParamName || label;
    this.state.processData = processData
    this.state.hide = props.hide

    if (setValue && defaultValue) {
      this.getDefaultValue(defaultValue)
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillMount() {
    const {items, defaultValue, value} = this.state;

    if (Objects.nonEmptyOrBlank(defaultValue)) {
      if (!Objects.isNullOrUndefined(items)) {
        const defaultValueObject = items.filter(x => x[value] === defaultValue)[0];
        this.setState({defaultValue: defaultValueObject});
        return;
      }
      this.setState({loading: false, defaultValue: defaultValue});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({defaultValue: nextProps.defaultValue});
    }
  }

  getDefaultValue(defaultValue) {
    if (defaultValue) {
      return;
    }
    if (Array.isArray(defaultValue) || typeof defaultValue !== 'object') {
      this.props.setValue(defaultValue)
    } else {
      this.props.setValue(defaultValue.id)
    }
  }

  handleOnChange = (value) => {
    this.setState({defaultValue: value});
    if (Array.isArray(value)) {
      this.props.setValue && this.props.setValue(value);
      return;
    }
    this.props.setValue && this.props.setValue(value && value.id);
    this.props.onChange && this.props.onChange(value);

  };

  loadData() {
    const {url, items, label, value, mapItems, filterItems, processData} = this.state;

    if (items) {
      this.setState({items: items})
      return;
    }

    this.httpRequest.get(url).then(
      (data) => {
        let options = data.content || data;

        if (processData) {
          options = processData(options)
        }

        if (filterItems) {
          options = options.filter(filterItems);
        }

        if (mapItems) {
          options = options.map(mapItems);
        }

        const content = options.map(
          item => BaseSelectorReadonlyToInputV2.mapItems(item, label, value));
        this.setState({items: content})

      },
      (error) => {
        Notify.error('Falha ao buscar dados: ' + error);
      }
    )
  }

  static mapItems(item, label = 'name', value = 'id') {
    const obejct = item;
    obejct[value] = item[value];
    obejct[label] = BaseSelectorReadonlyToInputV2.getLabel(item, label);
    return obejct;
  }

  static getLabel(item, fields) {
    let label = '';
    if (Array.isArray(fields)) {
      let text = [];
      fields.forEach((field) => {
        text.push(BaseSelectorReadonlyToInputV2.getValueFromLabel(item, field));
      });
      label = text.join(' - ');
    } else {
      label = BaseSelectorReadonlyToInputV2.getValueFromLabel(item, fields);
    }
    return label;
  }

  static getValueFromLabel(item, field) {
    if (field.indexOf('.') > 0) {
      let value = item;

      field.split('.').forEach(f => {
        value = value[f];
      });
      return value;
    }
    return item[field];
  }

  render() {
    const {required, readonly = false, multiple, hide, openToTop} = this.props;
    const {title, label, value, items, defaultValue, loading = false, style} = this.state;

    if (loading) {
      return <Loading/>;
    }

    if (hide) {
      return null
    }

    return (
      <FormGroup className={openToTop && 'select-up'}>
        <ControlLabel>{`${title}${required ? ' *' : ''}`}</ControlLabel>
        <Select multi={multiple}
                value={defaultValue}
                disabled={readonly}
                onChange={this.handleOnChange}
                valueKey={value}
                labelKey={label}
                required={required}
                placeholder={this.props.placeholder || "-- selecione --"}
                options={items}
                style={style}/>
      </FormGroup>
    );
  }

}

BaseSelectorReadonlyToInputV2.propTypes = {
  url: PropTypes.string,
  items: PropTypes.array,
  name: PropTypes.string,
  title: PropTypes.string.isRequired,
  fieldId: PropTypes.string,
  fieldValue: PropTypes.any,
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.any,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  filterItems: PropTypes.func,
  mapItems: PropTypes.func,
  multiple: PropTypes.bool
};

export default BaseSelectorReadonlyToInputV2;



// WEBPACK FOOTER //
// ./src/component/Select/BaseSelectorReadonlyToInputV2.js